import React, { useEffect, useRef } from "react";
import Logo from "../Logo/Logo";
import Announcement from "../Announcement/Announcement";
import LocationMenu from "../Location/LocationMenu";
import Menu from "../Menu/Menu";
import Character from "../Character/Character";
import gsap from "gsap";

const Banner = () => {
  const sugarRef = useRef(null);
  const sugarPowderRef = useRef(null);
  const windowWidth = window.innerWidth;
  const actionButton = useRef(null);

  useEffect(() => {
    if (windowWidth >= 1024) {
      gsap.to(sugarRef.current, {
        duration: 5,
        right: 0,
        opacity: 1,
        top: "50%"
      });

      gsap.to(sugarPowderRef.current, {
        duration: 4,
        right: 0,
        opacity: 1,
        top: "5%"
      });
    } else if (windowWidth >= 768) {
      gsap.to(sugarRef.current, {
        duration: 5,
        right: 0,
        opacity: 0.5,
        top: "0"
      });

      gsap.to(sugarPowderRef.current, {
        duration: 4,
        right: 0,
        opacity: 0.5,
        top: "0"
      });
    } else {
      gsap.to(sugarRef.current, {
        duration: 5,
        right: 0,
        opacity: 0.5,
        top: "0"
      });

      gsap.to(sugarPowderRef.current, {
        duration: 4,
        right: 0,
        opacity: 0.5,
        top: "0"
      });
    }
  }, [windowWidth]);

  useEffect(() => {
    gsap.to(actionButton.current, {
      delay: 3,
      duration: 3,
      opacity: 1
    });
  }, []);

  return (
    <div className="bs-banner">
      <Menu />
      <LocationMenu
        label="Find a location"
        position="right"
        location1="https://goo.gl/maps/k84WK4SqxdQfL4ZP7"
      />
      <Character />
      <Logo />
      <Announcement />
      <div ref={actionButton}>
        <LocationMenu
          location1="https://www.clover.com/online-ordering/beignet-spot-riverside-2"
          label="Order Online"
          location="center"
        />
      </div>
      <div ref={sugarRef} className="bs-banner--sugar"></div>
      <div ref={sugarPowderRef} className="bs-banner--sugar_powder"></div>
    </div>
  );
};

export default Banner;
